import { jsx as It } from "react/jsx-runtime";
import { useRef as Gt, useState as Ht, useCallback as sn, useEffect as rt, useMemo as cn, Children as un } from "react";
function fn(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Rt(t) {
  return fn(t) || Array.isArray(t);
}
function an() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function At(t, n) {
  const r = Object.keys(t), s = Object.keys(n);
  if (r.length !== s.length) return !1;
  const c = JSON.stringify(Object.keys(t.breakpoints || {})), o = JSON.stringify(Object.keys(n.breakpoints || {}));
  return c !== o ? !1 : r.every((e) => {
    const u = t[e], i = n[e];
    return typeof u == "function" ? `${u}` == `${i}` : !Rt(u) || !Rt(i) ? u === i : At(u, i);
  });
}
function qt(t) {
  return t.concat().sort((n, r) => n.name > r.name ? 1 : -1).map((n) => n.options);
}
function ln(t, n) {
  if (t.length !== n.length) return !1;
  const r = qt(t), s = qt(n);
  return r.every((c, o) => {
    const e = s[o];
    return At(c, e);
  });
}
function Ot(t) {
  return typeof t == "number";
}
function Tt(t) {
  return typeof t == "string";
}
function St(t) {
  return typeof t == "boolean";
}
function $t(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function w(t) {
  return Math.abs(t);
}
function Mt(t) {
  return Math.sign(t);
}
function at(t, n) {
  return w(t - n);
}
function dn(t, n) {
  if (t === 0 || n === 0 || w(t) <= w(n)) return 0;
  const r = at(w(t), w(n));
  return w(r / t);
}
function pn(t) {
  return Math.round(t * 100) / 100;
}
function lt(t) {
  return dt(t).map(Number);
}
function j(t) {
  return t[mt(t)];
}
function mt(t) {
  return Math.max(0, t.length - 1);
}
function Dt(t, n) {
  return n === mt(t);
}
function Ut(t, n = 0) {
  return Array.from(Array(t), (r, s) => n + s);
}
function dt(t) {
  return Object.keys(t);
}
function Kt(t, n) {
  return [t, n].reduce((r, s) => (dt(s).forEach((c) => {
    const o = r[c], e = s[c], u = $t(o) && $t(e);
    r[c] = u ? Kt(o, e) : e;
  }), r), {});
}
function vt(t, n) {
  return typeof n.MouseEvent < "u" && t instanceof n.MouseEvent;
}
function mn(t, n) {
  const r = {
    start: s,
    center: c,
    end: o
  };
  function s() {
    return 0;
  }
  function c(i) {
    return o(i) / 2;
  }
  function o(i) {
    return n - i;
  }
  function e(i, f) {
    return Tt(t) ? r[t](i) : t(n, i, f);
  }
  return {
    measure: e
  };
}
function pt() {
  let t = [];
  function n(c, o, e, u = {
    passive: !0
  }) {
    let i;
    if ("addEventListener" in c)
      c.addEventListener(o, e, u), i = () => c.removeEventListener(o, e, u);
    else {
      const f = c;
      f.addListener(e), i = () => f.removeListener(e);
    }
    return t.push(i), s;
  }
  function r() {
    t = t.filter((c) => c());
  }
  const s = {
    add: n,
    clear: r
  };
  return s;
}
function gn(t, n, r, s) {
  const c = pt(), o = 1e3 / 60;
  let e = null, u = 0, i = 0;
  function f() {
    c.add(t, "visibilitychange", () => {
      t.hidden && l();
    });
  }
  function h() {
    b(), c.clear();
  }
  function d(g) {
    if (!i) return;
    e || (e = g, r(), r());
    const a = g - e;
    for (e = g, u += a; u >= o; )
      r(), u -= o;
    const S = u / o;
    s(S), i && (i = n.requestAnimationFrame(d));
  }
  function p() {
    i || (i = n.requestAnimationFrame(d));
  }
  function b() {
    n.cancelAnimationFrame(i), e = null, u = 0, i = 0;
  }
  function l() {
    e = null, u = 0;
  }
  return {
    init: f,
    destroy: h,
    start: p,
    stop: b,
    update: r,
    render: s
  };
}
function hn(t, n) {
  const r = n === "rtl", s = t === "y", c = s ? "y" : "x", o = s ? "x" : "y", e = !s && r ? -1 : 1, u = h(), i = d();
  function f(l) {
    const {
      height: m,
      width: g
    } = l;
    return s ? m : g;
  }
  function h() {
    return s ? "top" : r ? "right" : "left";
  }
  function d() {
    return s ? "bottom" : r ? "left" : "right";
  }
  function p(l) {
    return l * e;
  }
  return {
    scroll: c,
    cross: o,
    startEdge: u,
    endEdge: i,
    measureSize: f,
    direction: p
  };
}
function tt(t = 0, n = 0) {
  const r = w(t - n);
  function s(f) {
    return f < t;
  }
  function c(f) {
    return f > n;
  }
  function o(f) {
    return s(f) || c(f);
  }
  function e(f) {
    return o(f) ? s(f) ? t : n : f;
  }
  function u(f) {
    return r ? f - r * Math.ceil((f - n) / r) : f;
  }
  return {
    length: r,
    max: n,
    min: t,
    constrain: e,
    reachedAny: o,
    reachedMax: c,
    reachedMin: s,
    removeOffset: u
  };
}
function Qt(t, n, r) {
  const {
    constrain: s
  } = tt(0, t), c = t + 1;
  let o = e(n);
  function e(p) {
    return r ? w((c + p) % c) : s(p);
  }
  function u() {
    return o;
  }
  function i(p) {
    return o = e(p), d;
  }
  function f(p) {
    return h().set(u() + p);
  }
  function h() {
    return Qt(t, u(), r);
  }
  const d = {
    get: u,
    set: i,
    add: f,
    clone: h
  };
  return d;
}
function Sn(t, n, r, s, c, o, e, u, i, f, h, d, p, b, l, m, g, a, S) {
  const {
    cross: x,
    direction: I
  } = t, M = ["INPUT", "SELECT", "TEXTAREA"], T = {
    passive: !1
  }, E = pt(), L = pt(), v = tt(50, 225).constrain(b.measure(20)), P = {
    mouse: 300,
    touch: 400
  }, A = {
    mouse: 500,
    touch: 600
  }, N = l ? 43 : 25;
  let z = !1, G = 0, H = 0, _ = !1, X = !1, $ = !1, U = !1;
  function st(y) {
    if (!S) return;
    function O(k) {
      (St(S) || S(y, k)) && ct(k);
    }
    const F = n;
    E.add(F, "dragstart", (k) => k.preventDefault(), T).add(F, "touchmove", () => {
    }, T).add(F, "touchend", () => {
    }).add(F, "touchstart", O).add(F, "mousedown", O).add(F, "touchcancel", C).add(F, "contextmenu", C).add(F, "click", Q, !0);
  }
  function R() {
    E.clear(), L.clear();
  }
  function nt() {
    const y = U ? r : n;
    L.add(y, "touchmove", B, T).add(y, "touchend", C).add(y, "mousemove", B, T).add(y, "mouseup", C);
  }
  function et(y) {
    const O = y.nodeName || "";
    return M.includes(O);
  }
  function K() {
    return (l ? A : P)[U ? "mouse" : "touch"];
  }
  function it(y, O) {
    const F = d.add(Mt(y) * -1), k = h.byDistance(y, !l).distance;
    return l || w(y) < v ? k : g && O ? k * 0.5 : h.byIndex(F.get(), 0).distance;
  }
  function ct(y) {
    const O = vt(y, s);
    U = O, $ = l && O && !y.buttons && z, z = at(c.get(), e.get()) >= 2, !(O && y.button !== 0) && (et(y.target) || (_ = !0, o.pointerDown(y), f.useFriction(0).useDuration(0), c.set(e), nt(), G = o.readPoint(y), H = o.readPoint(y, x), p.emit("pointerDown")));
  }
  function B(y) {
    if (!vt(y, s) && y.touches.length >= 2) return C(y);
    const F = o.readPoint(y), k = o.readPoint(y, x), q = at(F, G), J = at(k, H);
    if (!X && !U && (!y.cancelable || (X = q > J, !X)))
      return C(y);
    const Z = o.pointerMove(y);
    q > m && ($ = !0), f.useFriction(0.3).useDuration(0.75), u.start(), c.add(I(Z)), y.preventDefault();
  }
  function C(y) {
    const F = h.byDistance(0, !1).index !== d.get(), k = o.pointerUp(y) * K(), q = it(I(k), F), J = dn(k, q), Z = N - 10 * J, Y = a + J / 50;
    X = !1, _ = !1, L.clear(), f.useDuration(Z).useFriction(Y), i.distance(q, !l), U = !1, p.emit("pointerUp");
  }
  function Q(y) {
    $ && (y.stopPropagation(), y.preventDefault(), $ = !1);
  }
  function V() {
    return _;
  }
  return {
    init: st,
    destroy: R,
    pointerDown: V
  };
}
function yn(t, n) {
  let s, c;
  function o(d) {
    return d.timeStamp;
  }
  function e(d, p) {
    const l = `client${(p || t.scroll) === "x" ? "X" : "Y"}`;
    return (vt(d, n) ? d : d.touches[0])[l];
  }
  function u(d) {
    return s = d, c = d, e(d);
  }
  function i(d) {
    const p = e(d) - e(c), b = o(d) - o(s) > 170;
    return c = d, b && (s = d), p;
  }
  function f(d) {
    if (!s || !c) return 0;
    const p = e(c) - e(s), b = o(d) - o(s), l = o(d) - o(c) > 170, m = p / b;
    return b && !l && w(m) > 0.1 ? m : 0;
  }
  return {
    pointerDown: u,
    pointerMove: i,
    pointerUp: f,
    readPoint: e
  };
}
function bn() {
  function t(r) {
    const {
      offsetTop: s,
      offsetLeft: c,
      offsetWidth: o,
      offsetHeight: e
    } = r;
    return {
      top: s,
      right: c + o,
      bottom: s + e,
      left: c,
      width: o,
      height: e
    };
  }
  return {
    measure: t
  };
}
function xn(t) {
  function n(s) {
    return t * (s / 100);
  }
  return {
    measure: n
  };
}
function En(t, n, r, s, c, o, e) {
  const u = [t].concat(s);
  let i, f, h = [], d = !1;
  function p(g) {
    return c.measureSize(e.measure(g));
  }
  function b(g) {
    if (!o) return;
    f = p(t), h = s.map(p);
    function a(S) {
      for (const x of S) {
        if (d) return;
        const I = x.target === t, M = s.indexOf(x.target), T = I ? f : h[M], E = p(I ? t : s[M]);
        if (w(E - T) >= 0.5) {
          g.reInit(), n.emit("resize");
          break;
        }
      }
    }
    i = new ResizeObserver((S) => {
      (St(o) || o(g, S)) && a(S);
    }), r.requestAnimationFrame(() => {
      u.forEach((S) => i.observe(S));
    });
  }
  function l() {
    d = !0, i && i.disconnect();
  }
  return {
    init: b,
    destroy: l
  };
}
function Ln(t, n, r, s, c, o) {
  let e = 0, u = 0, i = c, f = o, h = t.get(), d = 0;
  function p() {
    const T = s.get() - t.get(), E = !i;
    let L = 0;
    return E ? (e = 0, r.set(s), t.set(s), L = T) : (r.set(t), e += T / i, e *= f, h += e, t.add(e), L = h - d), u = Mt(L), d = h, M;
  }
  function b() {
    const T = s.get() - n.get();
    return w(T) < 1e-3;
  }
  function l() {
    return i;
  }
  function m() {
    return u;
  }
  function g() {
    return e;
  }
  function a() {
    return x(c);
  }
  function S() {
    return I(o);
  }
  function x(T) {
    return i = T, M;
  }
  function I(T) {
    return f = T, M;
  }
  const M = {
    direction: m,
    duration: l,
    velocity: g,
    seek: p,
    settled: b,
    useBaseFriction: S,
    useBaseDuration: a,
    useFriction: I,
    useDuration: x
  };
  return M;
}
function In(t, n, r, s, c) {
  const o = c.measure(10), e = c.measure(50), u = tt(0.1, 0.99);
  let i = !1;
  function f() {
    return !(i || !t.reachedAny(r.get()) || !t.reachedAny(n.get()));
  }
  function h(b) {
    if (!f()) return;
    const l = t.reachedMin(n.get()) ? "min" : "max", m = w(t[l] - n.get()), g = r.get() - n.get(), a = u.constrain(m / e);
    r.subtract(g * a), !b && w(g) < o && (r.set(t.constrain(r.get())), s.useDuration(25).useBaseFriction());
  }
  function d(b) {
    i = !b;
  }
  return {
    shouldConstrain: f,
    constrain: h,
    toggleActive: d
  };
}
function Tn(t, n, r, s, c) {
  const o = tt(-n + t, 0), e = d(), u = h(), i = p();
  function f(l, m) {
    return at(l, m) <= 1;
  }
  function h() {
    const l = e[0], m = j(e), g = e.lastIndexOf(l), a = e.indexOf(m) + 1;
    return tt(g, a);
  }
  function d() {
    return r.map((l, m) => {
      const {
        min: g,
        max: a
      } = o, S = o.constrain(l), x = !m, I = Dt(r, m);
      return x ? a : I || f(g, S) ? g : f(a, S) ? a : S;
    }).map((l) => parseFloat(l.toFixed(3)));
  }
  function p() {
    if (n <= t + c) return [o.max];
    if (s === "keepSnaps") return e;
    const {
      min: l,
      max: m
    } = u;
    return e.slice(l, m);
  }
  return {
    snapsContained: i,
    scrollContainLimit: u
  };
}
function vn(t, n, r) {
  const s = n[0], c = r ? s - t : j(n);
  return {
    limit: tt(c, s)
  };
}
function An(t, n, r, s) {
  const o = n.min + 0.1, e = n.max + 0.1, {
    reachedMin: u,
    reachedMax: i
  } = tt(o, e);
  function f(p) {
    return p === 1 ? i(r.get()) : p === -1 ? u(r.get()) : !1;
  }
  function h(p) {
    if (!f(p)) return;
    const b = t * (p * -1);
    s.forEach((l) => l.add(b));
  }
  return {
    loop: h
  };
}
function On(t) {
  const {
    max: n,
    length: r
  } = t;
  function s(o) {
    const e = o - n;
    return r ? e / -r : 0;
  }
  return {
    get: s
  };
}
function Mn(t, n, r, s, c) {
  const {
    startEdge: o,
    endEdge: e
  } = t, {
    groupSlides: u
  } = c, i = d().map(n.measure), f = p(), h = b();
  function d() {
    return u(s).map((m) => j(m)[e] - m[0][o]).map(w);
  }
  function p() {
    return s.map((m) => r[o] - m[o]).map((m) => -w(m));
  }
  function b() {
    return u(f).map((m) => m[0]).map((m, g) => m + i[g]);
  }
  return {
    snaps: f,
    snapsAligned: h
  };
}
function Dn(t, n, r, s, c, o) {
  const {
    groupSlides: e
  } = c, {
    min: u,
    max: i
  } = s, f = h();
  function h() {
    const p = e(o), b = !t || n === "keepSnaps";
    return r.length === 1 ? [o] : b ? p : p.slice(u, i).map((l, m, g) => {
      const a = !m, S = Dt(g, m);
      if (a) {
        const x = j(g[0]) + 1;
        return Ut(x);
      }
      if (S) {
        const x = mt(o) - j(g)[0] + 1;
        return Ut(x, j(g)[0]);
      }
      return l;
    });
  }
  return {
    slideRegistry: f
  };
}
function wn(t, n, r, s, c) {
  const {
    reachedAny: o,
    removeOffset: e,
    constrain: u
  } = s;
  function i(l) {
    return l.concat().sort((m, g) => w(m) - w(g))[0];
  }
  function f(l) {
    const m = t ? e(l) : u(l), g = n.map((S, x) => ({
      diff: h(S - m, 0),
      index: x
    })).sort((S, x) => w(S.diff) - w(x.diff)), {
      index: a
    } = g[0];
    return {
      index: a,
      distance: m
    };
  }
  function h(l, m) {
    const g = [l, l + r, l - r];
    if (!t) return l;
    if (!m) return i(g);
    const a = g.filter((S) => Mt(S) === m);
    return a.length ? i(a) : j(g) - r;
  }
  function d(l, m) {
    const g = n[l] - c.get(), a = h(g, m);
    return {
      index: l,
      distance: a
    };
  }
  function p(l, m) {
    const g = c.get() + l, {
      index: a,
      distance: S
    } = f(g), x = !t && o(g);
    if (!m || x) return {
      index: a,
      distance: l
    };
    const I = n[a] - S, M = l + h(I, 0);
    return {
      index: a,
      distance: M
    };
  }
  return {
    byDistance: p,
    byIndex: d,
    shortcut: h
  };
}
function Pn(t, n, r, s, c, o, e) {
  function u(d) {
    const p = d.distance, b = d.index !== n.get();
    o.add(p), p && (s.duration() ? t.start() : (t.update(), t.render(1), t.update())), b && (r.set(n.get()), n.set(d.index), e.emit("select"));
  }
  function i(d, p) {
    const b = c.byDistance(d, p);
    u(b);
  }
  function f(d, p) {
    const b = n.clone().set(d), l = c.byIndex(b.get(), p);
    u(l);
  }
  return {
    distance: i,
    index: f
  };
}
function Fn(t, n, r, s, c, o, e, u) {
  const i = {
    passive: !0,
    capture: !0
  };
  let f = 0;
  function h(b) {
    if (!u) return;
    function l(m) {
      if ((/* @__PURE__ */ new Date()).getTime() - f > 10) return;
      e.emit("slideFocusStart"), t.scrollLeft = 0;
      const S = r.findIndex((x) => x.includes(m));
      Ot(S) && (c.useDuration(0), s.index(S, 0), e.emit("slideFocus"));
    }
    o.add(document, "keydown", d, !1), n.forEach((m, g) => {
      o.add(m, "focus", (a) => {
        (St(u) || u(b, a)) && l(g);
      }, i);
    });
  }
  function d(b) {
    b.code === "Tab" && (f = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: h
  };
}
function ft(t) {
  let n = t;
  function r() {
    return n;
  }
  function s(i) {
    n = e(i);
  }
  function c(i) {
    n += e(i);
  }
  function o(i) {
    n -= e(i);
  }
  function e(i) {
    return Ot(i) ? i : i.get();
  }
  return {
    get: r,
    set: s,
    add: c,
    subtract: o
  };
}
function Jt(t, n) {
  const r = t.scroll === "x" ? e : u, s = n.style;
  let c = null, o = !1;
  function e(p) {
    return `translate3d(${p}px,0px,0px)`;
  }
  function u(p) {
    return `translate3d(0px,${p}px,0px)`;
  }
  function i(p) {
    if (o) return;
    const b = pn(t.direction(p));
    b !== c && (s.transform = r(b), c = b);
  }
  function f(p) {
    o = !p;
  }
  function h() {
    o || (s.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: h,
    to: i,
    toggleActive: f
  };
}
function Cn(t, n, r, s, c, o, e, u, i) {
  const h = lt(c), d = lt(c).reverse(), p = a().concat(S());
  function b(E, L) {
    return E.reduce((v, P) => v - c[P], L);
  }
  function l(E, L) {
    return E.reduce((v, P) => b(v, L) > 0 ? v.concat([P]) : v, []);
  }
  function m(E) {
    return o.map((L, v) => ({
      start: L - s[v] + 0.5 + E,
      end: L + n - 0.5 + E
    }));
  }
  function g(E, L, v) {
    const P = m(L);
    return E.map((A) => {
      const N = v ? 0 : -r, z = v ? r : 0, G = v ? "end" : "start", H = P[A][G];
      return {
        index: A,
        loopPoint: H,
        slideLocation: ft(-1),
        translate: Jt(t, i[A]),
        target: () => u.get() > H ? N : z
      };
    });
  }
  function a() {
    const E = e[0], L = l(d, E);
    return g(L, r, !1);
  }
  function S() {
    const E = n - e[0] - 1, L = l(h, E);
    return g(L, -r, !0);
  }
  function x() {
    return p.every(({
      index: E
    }) => {
      const L = h.filter((v) => v !== E);
      return b(L, n) <= 0.1;
    });
  }
  function I() {
    p.forEach((E) => {
      const {
        target: L,
        translate: v,
        slideLocation: P
      } = E, A = L();
      A !== P.get() && (v.to(A), P.set(A));
    });
  }
  function M() {
    p.forEach((E) => E.translate.clear());
  }
  return {
    canLoop: x,
    clear: M,
    loop: I,
    loopPoints: p
  };
}
function kn(t, n, r) {
  let s, c = !1;
  function o(i) {
    if (!r) return;
    function f(h) {
      for (const d of h)
        if (d.type === "childList") {
          i.reInit(), n.emit("slidesChanged");
          break;
        }
    }
    s = new MutationObserver((h) => {
      c || (St(r) || r(i, h)) && f(h);
    }), s.observe(t, {
      childList: !0
    });
  }
  function e() {
    s && s.disconnect(), c = !0;
  }
  return {
    init: o,
    destroy: e
  };
}
function Nn(t, n, r, s) {
  const c = {};
  let o = null, e = null, u, i = !1;
  function f() {
    u = new IntersectionObserver((l) => {
      i || (l.forEach((m) => {
        const g = n.indexOf(m.target);
        c[g] = m;
      }), o = null, e = null, r.emit("slidesInView"));
    }, {
      root: t.parentElement,
      threshold: s
    }), n.forEach((l) => u.observe(l));
  }
  function h() {
    u && u.disconnect(), i = !0;
  }
  function d(l) {
    return dt(c).reduce((m, g) => {
      const a = parseInt(g), {
        isIntersecting: S
      } = c[a];
      return (l && S || !l && !S) && m.push(a), m;
    }, []);
  }
  function p(l = !0) {
    if (l && o) return o;
    if (!l && e) return e;
    const m = d(l);
    return l && (o = m), l || (e = m), m;
  }
  return {
    init: f,
    destroy: h,
    get: p
  };
}
function Bn(t, n, r, s, c, o) {
  const {
    measureSize: e,
    startEdge: u,
    endEdge: i
  } = t, f = r[0] && c, h = l(), d = m(), p = r.map(e), b = g();
  function l() {
    if (!f) return 0;
    const S = r[0];
    return w(n[u] - S[u]);
  }
  function m() {
    if (!f) return 0;
    const S = o.getComputedStyle(j(s));
    return parseFloat(S.getPropertyValue(`margin-${i}`));
  }
  function g() {
    return r.map((S, x, I) => {
      const M = !x, T = Dt(I, x);
      return M ? p[x] + h : T ? p[x] + d : I[x + 1][u] - S[u];
    }).map(w);
  }
  return {
    slideSizes: p,
    slideSizesWithGaps: b,
    startGap: h,
    endGap: d
  };
}
function Vn(t, n, r, s, c, o, e, u, i) {
  const {
    startEdge: f,
    endEdge: h,
    direction: d
  } = t, p = Ot(r);
  function b(a, S) {
    return lt(a).filter((x) => x % S === 0).map((x) => a.slice(x, x + S));
  }
  function l(a) {
    return a.length ? lt(a).reduce((S, x, I) => {
      const M = j(S) || 0, T = M === 0, E = x === mt(a), L = c[f] - o[M][f], v = c[f] - o[x][h], P = !s && T ? d(e) : 0, A = !s && E ? d(u) : 0, N = w(v - A - (L + P));
      return I && N > n + i && S.push(x), E && S.push(a.length), S;
    }, []).map((S, x, I) => {
      const M = Math.max(I[x - 1] || 0);
      return a.slice(M, S);
    }) : [];
  }
  function m(a) {
    return p ? b(a, r) : l(a);
  }
  return {
    groupSlides: m
  };
}
function jn(t, n, r, s, c, o, e) {
  const {
    align: u,
    axis: i,
    direction: f,
    startIndex: h,
    loop: d,
    duration: p,
    dragFree: b,
    dragThreshold: l,
    inViewThreshold: m,
    slidesToScroll: g,
    skipSnaps: a,
    containScroll: S,
    watchResize: x,
    watchSlides: I,
    watchDrag: M,
    watchFocus: T
  } = o, E = 2, L = bn(), v = L.measure(n), P = r.map(L.measure), A = hn(i, f), N = A.measureSize(v), z = xn(N), G = mn(u, N), H = !d && !!S, _ = d || !!S, {
    slideSizes: X,
    slideSizesWithGaps: $,
    startGap: U,
    endGap: st
  } = Bn(A, v, P, r, _, c), R = Vn(A, N, g, d, v, P, U, st, E), {
    snaps: nt,
    snapsAligned: et
  } = Mn(A, G, v, P, R), K = -j(nt) + j($), {
    snapsContained: it,
    scrollContainLimit: ct
  } = Tn(N, K, et, S, E), B = H ? it : et, {
    limit: C
  } = vn(K, B, d), Q = Qt(mt(B), h, d), V = Q.clone(), D = lt(r), y = ({
    dragHandler: ot,
    scrollBody: Et,
    scrollBounds: Lt,
    options: {
      loop: gt
    }
  }) => {
    gt || Lt.constrain(ot.pointerDown()), Et.seek();
  }, O = ({
    scrollBody: ot,
    translate: Et,
    location: Lt,
    offsetLocation: gt,
    previousLocation: _t,
    scrollLooper: Zt,
    slideLooper: Wt,
    dragHandler: tn,
    animation: nn,
    eventHandler: kt,
    scrollBounds: en,
    options: {
      loop: Nt
    }
  }, Bt) => {
    const Vt = ot.settled(), on = !en.shouldConstrain(), jt = Nt ? Vt : Vt && on, zt = jt && !tn.pointerDown();
    zt && nn.stop();
    const rn = Lt.get() * Bt + _t.get() * (1 - Bt);
    gt.set(rn), Nt && (Zt.loop(ot.direction()), Wt.loop()), Et.to(gt.get()), zt && kt.emit("settle"), jt || kt.emit("scroll");
  }, F = gn(s, c, () => y(xt), (ot) => O(xt, ot)), k = 0.68, q = B[Q.get()], J = ft(q), Z = ft(q), Y = ft(q), W = ft(q), ut = Ln(J, Y, Z, W, p, k), yt = wn(d, B, K, C, W), bt = Pn(F, Q, V, ut, yt, W, e), Pt = On(C), Ft = pt(), Xt = Nn(n, r, e, m), {
    slideRegistry: Ct
  } = Dn(H, S, B, ct, R, D), Yt = Fn(t, r, Ct, bt, ut, Ft, e, T), xt = {
    ownerDocument: s,
    ownerWindow: c,
    eventHandler: e,
    containerRect: v,
    slideRects: P,
    animation: F,
    axis: A,
    dragHandler: Sn(A, t, s, c, W, yn(A, c), J, F, bt, ut, yt, Q, e, z, b, l, a, k, M),
    eventStore: Ft,
    percentOfView: z,
    index: Q,
    indexPrevious: V,
    limit: C,
    location: J,
    offsetLocation: Y,
    previousLocation: Z,
    options: o,
    resizeHandler: En(n, e, c, r, A, x, L),
    scrollBody: ut,
    scrollBounds: In(C, Y, W, ut, z),
    scrollLooper: An(K, C, Y, [J, Y, Z, W]),
    scrollProgress: Pt,
    scrollSnapList: B.map(Pt.get),
    scrollSnaps: B,
    scrollTarget: yt,
    scrollTo: bt,
    slideLooper: Cn(A, N, K, X, $, nt, B, Y, r),
    slideFocus: Yt,
    slidesHandler: kn(n, e, I),
    slidesInView: Xt,
    slideIndexes: D,
    slideRegistry: Ct,
    slidesToScroll: R,
    target: W,
    translate: Jt(A, n)
  };
  return xt;
}
function zn() {
  let t = {}, n;
  function r(f) {
    n = f;
  }
  function s(f) {
    return t[f] || [];
  }
  function c(f) {
    return s(f).forEach((h) => h(n, f)), i;
  }
  function o(f, h) {
    return t[f] = s(f).concat([h]), i;
  }
  function e(f, h) {
    return t[f] = s(f).filter((d) => d !== h), i;
  }
  function u() {
    t = {};
  }
  const i = {
    init: r,
    emit: c,
    off: e,
    on: o,
    clear: u
  };
  return i;
}
const Gn = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Hn(t) {
  function n(o, e) {
    return Kt(o, e || {});
  }
  function r(o) {
    const e = o.breakpoints || {}, u = dt(e).filter((i) => t.matchMedia(i).matches).map((i) => e[i]).reduce((i, f) => n(i, f), {});
    return n(o, u);
  }
  function s(o) {
    return o.map((e) => dt(e.breakpoints || {})).reduce((e, u) => e.concat(u), []).map(t.matchMedia);
  }
  return {
    mergeOptions: n,
    optionsAtMedia: r,
    optionsMediaQueries: s
  };
}
function Rn(t) {
  let n = [];
  function r(o, e) {
    return n = e.filter(({
      options: u
    }) => t.optionsAtMedia(u).active !== !1), n.forEach((u) => u.init(o, t)), e.reduce((u, i) => Object.assign(u, {
      [i.name]: i
    }), {});
  }
  function s() {
    n = n.filter((o) => o.destroy());
  }
  return {
    init: r,
    destroy: s
  };
}
function ht(t, n, r) {
  const s = t.ownerDocument, c = s.defaultView, o = Hn(c), e = Rn(o), u = pt(), i = zn(), {
    mergeOptions: f,
    optionsAtMedia: h,
    optionsMediaQueries: d
  } = o, {
    on: p,
    off: b,
    emit: l
  } = i, m = A;
  let g = !1, a, S = f(Gn, ht.globalOptions), x = f(S), I = [], M, T, E;
  function L() {
    const {
      container: D,
      slides: y
    } = x;
    T = (Tt(D) ? t.querySelector(D) : D) || t.children[0];
    const F = Tt(y) ? T.querySelectorAll(y) : y;
    E = [].slice.call(F || T.children);
  }
  function v(D) {
    const y = jn(t, T, E, s, c, D, i);
    if (D.loop && !y.slideLooper.canLoop()) {
      const O = Object.assign({}, D, {
        loop: !1
      });
      return v(O);
    }
    return y;
  }
  function P(D, y) {
    g || (S = f(S, D), x = h(S), I = y || I, L(), a = v(x), d([S, ...I.map(({
      options: O
    }) => O)]).forEach((O) => u.add(O, "change", A)), x.active && (a.translate.to(a.location.get()), a.animation.init(), a.slidesInView.init(), a.slideFocus.init(V), a.eventHandler.init(V), a.resizeHandler.init(V), a.slidesHandler.init(V), a.options.loop && a.slideLooper.loop(), T.offsetParent && E.length && a.dragHandler.init(V), M = e.init(V, I)));
  }
  function A(D, y) {
    const O = R();
    N(), P(f({
      startIndex: O
    }, D), y), i.emit("reInit");
  }
  function N() {
    a.dragHandler.destroy(), a.eventStore.clear(), a.translate.clear(), a.slideLooper.clear(), a.resizeHandler.destroy(), a.slidesHandler.destroy(), a.slidesInView.destroy(), a.animation.destroy(), e.destroy(), u.clear();
  }
  function z() {
    g || (g = !0, u.clear(), N(), i.emit("destroy"), i.clear());
  }
  function G(D, y, O) {
    !x.active || g || (a.scrollBody.useBaseFriction().useDuration(y === !0 ? 0 : x.duration), a.scrollTo.index(D, O || 0));
  }
  function H(D) {
    const y = a.index.add(1).get();
    G(y, D, -1);
  }
  function _(D) {
    const y = a.index.add(-1).get();
    G(y, D, 1);
  }
  function X() {
    return a.index.add(1).get() !== R();
  }
  function $() {
    return a.index.add(-1).get() !== R();
  }
  function U() {
    return a.scrollSnapList;
  }
  function st() {
    return a.scrollProgress.get(a.offsetLocation.get());
  }
  function R() {
    return a.index.get();
  }
  function nt() {
    return a.indexPrevious.get();
  }
  function et() {
    return a.slidesInView.get();
  }
  function K() {
    return a.slidesInView.get(!1);
  }
  function it() {
    return M;
  }
  function ct() {
    return a;
  }
  function B() {
    return t;
  }
  function C() {
    return T;
  }
  function Q() {
    return E;
  }
  const V = {
    canScrollNext: X,
    canScrollPrev: $,
    containerNode: C,
    internalEngine: ct,
    destroy: z,
    off: b,
    on: p,
    emit: l,
    plugins: it,
    previousScrollSnap: nt,
    reInit: m,
    rootNode: B,
    scrollNext: H,
    scrollPrev: _,
    scrollProgress: st,
    scrollSnapList: U,
    scrollTo: G,
    selectedScrollSnap: R,
    slideNodes: Q,
    slidesInView: et,
    slidesNotInView: K
  };
  return P(n, r), setTimeout(() => i.emit("init"), 0), V;
}
ht.globalOptions = void 0;
function wt(t = {}, n = []) {
  const r = Gt(t), s = Gt(n), [c, o] = Ht(), [e, u] = Ht(), i = sn(() => {
    c && c.reInit(r.current, s.current);
  }, [c]);
  return rt(() => {
    At(r.current, t) || (r.current = t, i());
  }, [t, i]), rt(() => {
    ln(s.current, n) || (s.current = n, i());
  }, [n, i]), rt(() => {
    if (an() && e) {
      ht.globalOptions = wt.globalOptions;
      const f = ht(e, r.current, s.current);
      return o(f), () => f.destroy();
    } else
      o(void 0);
  }, [e, o]), [u, c];
}
wt.globalOptions = void 0;
const qn = {
  overflow: "hidden",
  width: "100%"
}, $n = {
  display: "flex",
  width: "100%",
  touchAction: "pan-y"
}, Un = {
  flex: "0 0 100%",
  minWidth: 0,
  width: "100%"
}, Kn = {
  axis: "x"
}, Xn = ({
  children: t,
  index: n,
  onChangeIndex: r
}) => {
  const s = cn(() => un.toArray(t), [t]), [c, o] = wt(Kn);
  return rt(() => {
    if (!o)
      return;
    const e = () => {
      if (!r)
        return;
      const u = o.selectedScrollSnap();
      r(u);
    };
    return o.on("select", e), () => {
      o.off("select", e);
    };
  }, [o, r]), rt(() => {
    if (!o || s.length === 0)
      return;
    const e = Number.isFinite(n) ? n : 0, u = Math.max(s.length - 1, 0), i = Math.min(Math.max(e, 0), u), f = o.selectedScrollSnap();
    Number.isFinite(i) && f !== i && o.scrollTo(i);
  }, [o, n, s.length]), rt(() => {
    o && o.reInit();
  }, [o, s.length]), /* @__PURE__ */ It("div", { ref: c, style: qn, children: /* @__PURE__ */ It("div", { style: $n, children: s.map((e, u) => /* @__PURE__ */ It(
    "div",
    {
      style: Un,
      children: e
    },
    // Children.toArray preserves keys when provided
    e?.key ?? u
  )) }) });
};
export {
  Xn as S
};
